import React, { useEffect } from 'react';
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { elStyle } from '../common/ContractTableHandlerCss';
import {
    CONTRACT_POLICY_CONTENT,
    CONTRACT_SCREEN_MANAGEMENT
} from '@/common/constant/NormalContractManagementConstant';
import { I18n } from 'aws-amplify';

export default function DialogPolicy({ openPolicy, onShow }) {
    const [open, setOpen] = React.useState(openPolicy);
    const [isCheckbox, setIsCheckbox] = React.useState(false);

    useEffect(() => {
        setOpen(openPolicy);
    }, [openPolicy]);

    const handleClose = kind => {
        setOpen(false);
        return onShow(kind);
    };

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-policy"
            aria-describedby="alert-dialog-policy"
            disableEscapeKeyDown
            maxWidth="md"
        >
            <DialogTitle id="customized-dialog-title" style={{ margin: 0, padding: 0 }}>
                <Box display="flex" justifyContent="flex-end">
                    <IconButton
                        onClick={e =>
                            handleClose(
                                CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.LABEL.KIND_BACK
                            )
                        }
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box component="span" {...elStyle.dialog_policy_title}>
                    {I18n.get('LABEL-TITLE-CONTRACT-POLICY')}
                </Box>
            </DialogTitle>
            <DialogContent dividers style={{ border: 'none' }}>
                <Box {...elStyle.dialog_policy_cotent_wrapper}>
                    <Box className="normal-collapse" {...elStyle.dialog_policy_cotent}>
                        {CONTRACT_POLICY_CONTENT.map((item, key) => (
                            <Typography component="div" gutterBottom key={key}>
                                <span>{`${item.term}`}</span>
                                <Box
                                    p="12px 0"
                                    dangerouslySetInnerHTML={{ __html: item.content }}
                                ></Box>
                            </Typography>
                        ))}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
                <Typography
                    component="span"
                    onClick={() => setIsCheckbox(!isCheckbox)}
                    style={{ cursor: 'default' }}
                >
                    <Checkbox
                        id="policy-checked"
                        inputProps={{ 'aria-label': 'policy-checked' }}
                        checked={isCheckbox}
                        color="primary"
                    />
                    <span>{I18n.get('LABEL-I-AGREE')}</span>
                </Typography>
                <Box display="flex" justifyContent="center">
                    <Button
                        className="btn-send btn-hg32 btn-primary"
                        onClick={e =>
                            handleClose(
                                CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.LABEL.KIND_NEXT
                            )
                        }
                        disabled={!isCheckbox}
                    >
                        <span>{I18n.get('USER11BTN002')}</span>
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
